import { render, staticRenderFns } from "./android14.vue?vue&type=template&id=8c9b986e&scoped=true"
import script from "./android14.vue?vue&type=script&lang=js"
export * from "./android14.vue?vue&type=script&lang=js"
import style0 from "./android14.vue?vue&type=style&index=0&id=8c9b986e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b986e",
  null
  
)

export default component.exports